import { Suspense } from 'react';
import { trackEvent } from '@kcd/event-tracker';

import ProductDisplayFrequentlyOrdered from '~/domains/products/components/ProductDisplayFrequentlyOrdered';
import { useFrequentlyOrderProducts } from '~/domains/products/queries';
import { useEffectOnce } from '~/hooks/lifecycle';
import FrequentlyOrderedDefaultView from '~/pages/offers/frequently-ordered/FrequentlyOrderedDefaultView';

const CartFrequentlyOrderedContainer = () => {
  const { data } = useFrequentlyOrderProducts();

  if (!data?.length) {
    return <FrequentlyOrderedDefaultView />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffectOnce(() => {
    trackEvent('viewed 마켓/자주 구매한상품 page', {
      productName: [...data.map(({ productName }) => productName)],
      offerId: [...data.map(({ offerId }) => offerId)],
    });
  });

  return (
    <div className="mt-16">
      <ProductDisplayFrequentlyOrdered data={data} />
    </div>
  );
};

function CartFrequentlyOrdered() {
  return (
    <Suspense fallback={<></>}>
      <CartFrequentlyOrderedContainer />
    </Suspense>
  );
}

export default CartFrequentlyOrdered;
